<template>
  <section v-if="tableData.length > 0" class="interest-chart-container">
    <div class="chart-title">
      利益演示总表
    </div>
    <div id="ContainerLine" class="container_line" style="height: 280px" />
    <p class="interest_chart_tips">
      拖动按钮，查看不同年龄段保单利益
    </p>
    <template v-for="key in chartBarKeys">
      <div v-if="getBarChartTitle(key)" :key="`title-${key}`" class="chart-title">
        {{ getBarChartTitle(key) }}
      </div>
      <div
        :id="`Container${key}`"
        :key="`container-${key}`"
        class="container_bar"
        style="height: 240px"
      />
    </template>
  </section>
</template>
<script>
import * as echarts from 'echarts';
import { get as _get } from 'lodash'
export default {
  props: {
    curProductInterestData: {
      type: Object,
      default: () => ({})
    },
    filterInterestDetailData: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    detailList () {
      return (this.filterInterestDetailData || []).filter(e => e.key !== 'remark')
    },
    chartBarKeys () {
      const keys = ['irr_value' , 'single_value']
      return keys.filter(key => !!this.detailList.find(item => item.key === key))
    },
    tableData () {
      const { params, curProductInterestData, filterInterestDetailData : values } = this
      const tableData = []
      if (!values || !curProductInterestData) {
        return tableData
      }
      const _insuredAge = _get(params, 'insuredAge')
      const _startPolicyNo = _get(curProductInterestData, 'startPolicyNo')
      const _startIndex = _get(curProductInterestData, 'startIndex')
      const maxlength = values.reduce((a, b) => Math.max(a, b.values.length || 0), 0);
      values.filter(e => e.values).forEach((item) => {
        for (let i = 0; i < maxlength; i++) {
          tableData[i] = tableData[i] || {
            year: i + _startPolicyNo,
            age: i + _insuredAge + _startIndex  + 1,
          }
          tableData[i][item.key] = item.values[i]
        }
      })
      return tableData
    }
  },
  watch: {
    curProductInterestData: {
      handler () {
        this.init()
      }
    },
    filterInterestDetailData: {
      handler () {
        this.init()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$nextTick(() => {
        this.drawLine()
        this.chartBarKeys.forEach(key => this.drawBar(key))
      })
    },
    drawLine () {
      const dom = document.getElementById('ContainerLine');
      if (!dom) {
        return
      }
      const { detailList, tableData, chartBarKeys } = this
      if (!detailList) {
        return []
      }

      const currentValues = detailList.filter(item => !chartBarKeys.includes(item.key))
      const legendData = currentValues.map(item => item.name)
      const approximateLegendHeight = 25 * Math.ceil(legendData.length / 2) // 图例高度近似值
      dom.style.height = approximateLegendHeight + 280 + 'px'
      const xAxisData = tableData.map(item => `${item.age}岁`)
      const seriesData = currentValues.map(item => {
        return {
          name: item.name,
          type: 'line',
          smooth: true,
          data: tableData.map(e => e[item.key])
        }
      })

      const option = {
        tooltip: {
          trigger: 'axis',
          triggerOn: 'none',
          confine: true,
          alwaysShowContent: false,
          className: 'echarts-tooltip',
          position: ['12%', 0],
          valueFormatter: value => {
            if (value < 10000) {
              return this.baseFixed(value)
            }
            if (value >= 10000) {
              return `${this.baseFixed(value / 10000)}万`
            }
            return value
          }
        },
        legend: {
          data: legendData
        },
        grid: {
          top: approximateLegendHeight + 10,
          right: 20,
          bottom: 80,
          left: 60
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#999999'
            }
          },
          axisLabel: {
            interval: (index, value) => {
              const _length = xAxisData.length
              const _value = parseInt(value)
              if (_length <= 9) {
                return true
              }
              if (_length <= 30) {
                return index === 0 || (index === _length - 1) || !(_value % 5)
              }
              return index === 0 || (index === _length - 1) || !(_value % 10)
            },
            showMinLabel: true,
            showMaxLabel: true
          },
          axisPointer: {
            value: 4,
            snap: true,
            lineStyle: {
              color: '#ddd',
              width: 1
            },
            label: {
              show: true,
              backgroundColor: '#5470c6'
            },
            handle: {
              show: true,
              size: 40,
              margin: 46,
              color: '#5470c6'
            }
          },
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: value => {
              return value >= 10000 ? `${value / 10000}万` : value
            }
          },
        },
        series: seriesData
      };
      const myChart = echarts.init(dom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });
      myChart.on('legendselectchanged', function (params) {
        let option = this.getOption()
        let select_value = Object.values(params.selected)
        if (select_value.every(val => !val)) {
          option.legend[0].selected[params.name] = true
        }
        this.setOption(option)
      })
      myChart.setOption(option)
    },
    getBarChartTitle (key) {
      const metricItem = this.detailList.find(value => value.key === key)
      return metricItem && metricItem.name || ''
    },
    drawBar (key) {
      const dom = document.getElementById(`Container${key}`);
      if (!dom) {
        return
      }
      const { detailList, tableData } = this
      if (!detailList) {
        return []
      }
      
      const currentValues = detailList.filter(value => value.key === key)
      const xAxisData = tableData.map(item => `${item.age}岁`)
      const markData = tableData.filter(item => item[key + '_flag']).map(item => ({
        name: '',
        coord: [item.age, item[key]],
        value: item[key + '_flag']
      }))
      const seriesData = currentValues.map(item => {
        return {
          name: item.name,
          type: 'bar',
          data: tableData.map(e => e[item.key]),
          emphasis: {
            focus: 'series'
          },
          markPoint: {
            data: markData
          }
        }
      })

      const option = {
        grid: {
          top: 10,
          right: 20,
          bottom: 20,
          left: 60
        },
        tooltip: {
          show: true,
          className: 'echarts-tooltip for-bar-chart',
          valueFormatter: value => {
            return value + '%'
          }
        },
        xAxis: {
          axisLabel: {
            interval: (index, value) => {
              const _length = xAxisData.length
              const _value = parseInt(value)
              if (_length <= 9) {
                return true
              }
              if (_length <= 30) {
                return index === 0 || index === _length - 1 || !(_value % 5)
              }
              return index === 0 || index === _length - 1 || !(_value % 10)
            },
            showMinLabel: true,
            showMaxLabel: true
          },
          data: xAxisData,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: value => {
              return ['irr_value', 'single_value', 'policy_cash_grow_rate'].includes(key) ? `${value.toFixed(2)}%` : value
            }
          },
        },
        series: seriesData
      };

      const myChart = echarts.init(dom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      });
      myChart.setOption(option);
    },
    baseFixed (value) {
      const valueArray = (value + '').split('.')
      if (valueArray[1] && valueArray[1].length > 2) {
        return value.toFixed(2)
      }
      return value
    },
  }
}
</script>
<style>
@import './interest-chart.css';
</style>
